import { useRouter } from 'next/navigation'
import { useEffect } from 'react'

import Loading from '@/features/common/components/Loading'
import { useAuth } from '@/shared/providers/Auth'

export default function Home() {
  const router = useRouter()
  const { profile } = useAuth()

  useEffect(() => {
    profile && router.push(`/courses`)
  }, [profile])

  return <Loading />
}
